import { CircularProgress, Typography } from '@mui/material';
import { RequestNextApi } from '../../api/Request';
import { getCookie } from '../../utils/cookieHandle';
import { ShowNotification } from '../../utils/notification/snackbarUtils';
import React from 'react';
import parse from 'html-react-parser';
import { useRouter } from 'next/router';

export default function BlogsIndex() {
  const [blogs, setBlogs] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const router = useRouter();

  React.useEffect(() => {
    const fetchBlogIndex = async () => {
      try {
        setLoading(true)
        const res = await RequestNextApi.post('/blog/fetch-all',
          {}
        );
        console.log(res.data.blogs?.[0]?.articleBlocks)
        if (res.data.success) {
          setBlogs(res.data.blogs)
        } else {
          ShowNotification.error('Fetch page failed');
        }
      } catch (error) {
        ShowNotification.error('Fetch page failed');
      } finally {
        setLoading(false)
      }
    };
    fetchBlogIndex();
  }, []);

  if (loading) {
    return <div className='flex flex-1 justify-center items-center py-10'>
      <CircularProgress size={24} />
    </div>
  }
  if (!blogs.length) {
    return <></>
  }


  return (
    <div
      className='py-2 rounded-xl mx-auto max-w-7xl grid grid-cols-3 gap-8'
    >
      {blogs.map((blog, index) => <div key={index} className='cursor-pointer border-[1px] border-solid border-[#BBBBBB] rounded-md overflow-hidden' onClick={() => {
        router.push(`/industry-leader/news/${blog.slug}`)
      }}>
        <img src={blog.thumbnail?.url} className='h-[150px] object-cover w-full' />
        <div className='p-4 flex flex-col overflow-hidden'>
          <div className='flex flex-1'>
            <Typography variant='h6' className='font-bold' style={{ lineHeight: 1.1 }}>{parse(blog.title ?? "")}</Typography>
          </div>
          <div className='flex flex-1 line-clamp-4'>
            <Typography variant='body' className='line-clamp-4'>{parse(blog.excerpt ?? "")}</Typography>
          </div>
        </div>
      </div>)}
    </div>
  )
}
